import { Map } from 'immutable';

import * as t from '../actions/bannerActionTypes';

const initialState = Map({
  bannersActive: [],
});

const reducer = function bannerReducer(state = initialState, action) {
  switch (action.type) {
    case t.SET_BANNERS_ACTIVE:
      return state.set('bannersActive', action.banners);
    default:
      return state;
  }
};

export default reducer;
